import { axios } from '../../../lib/axios';
import { SurveyItem } from '../types/index.ts'

export const getSurveyByIdAndPersonAPI = async ( idSurvey: number, order: number): Promise<SurveyItem> => {
    const response = await axios.get(`/survey/${idSurvey}/person`, {
        params: {
            order: order
           
        }
    }) as { item: SurveyItem };
    return response;
};

export const saveAnswerAPI = async (body) => {
    const response = await axios.post('/survey/answer', body);
    return response;
}
